

































































import { Vue, Component } from 'vue-property-decorator';
import { Picker, Field, Popup, Button } from 'vant';
import * as config from './config';
import { ProgramTree, ProgramDetail, PersonalTree } from './api';
import VoteButton from './components/VoteButton.vue';
import Title from './components/Title.vue';
Vue.use(Picker)
  .use(Field)
  .use(Popup)
  .use(Button);
@Component({
  components: {
    VoteButton,
    Title,
  },
})
export default class Selection extends Vue {
  option = config.OPTHINES;
  // 节目投票
  value: any = [];
  showPicker = false;
  columns: any = [];
  programVoteList: any = [];
  rankList = [
    {
      name: '最佳人气奖',
      color: 'rgb(255,242,206)',
      id: 1,
    },
    {
      name: '最佳创新奖',
      color: 'rgb(255,220,220)',
      id: 2,
    },
    {
      name: '最佳服饰奖',
      color: 'rgb(217,239,236)',
      id: 6,
    },
    {
      name: '最佳组织奖',
      color: 'rgb(218,239,216)',
      id: 7,
    },
    {
      name: '最佳艺术奖',
      color: 'rgb(217,228,239)',
      id: 5,
    },
    {
      name: '最佳表演奖',
      color: 'rgb(244,215,237)',
      id: 3,
    },
    {
      name: '最佳风采奖',
      color: 'rgb(219,210,236)',
      id: 4,
    },
  ];
  chooseProgramId = '';
  activeFiledIndex = 0;
  // 固定的节目名单
  programme: any = [];
  // 演员投票
  personalList = [];
  personalVoteList: any = [];
  async created() {
    if (this.$route.query.type === 'Three') {
      const personalRes = await PersonalTree(this.option.voteName);
      this.personalList = personalRes.data;
      personalRes.data.map((item: any, index: number) => {
        if (!item.enable) {
          this.value[index] = item.per_list[0].title;
        }
      });
    }
    if (this.$route.query.type === 'Two') {
      const newArray: any = [];
      const res = await ProgramTree(this.option.voteName);
      res.data.map((item: any) => {
        newArray.push({ text: item.title, id: item.id });
      });
      this.columns = newArray;
      this.programme = newArray;
    }
  }
  chooseShowPicker(index: number, item: any) {
    this.showPicker = true;
    this.activeFiledIndex = index;
    this.chooseProgramId = item.id;
  }
  onConfirm(e: any) {
    if (this.value[this.activeFiledIndex]) {
      this.columns.splice(this.activeFiledIndex, 0, {
        text: this.value[this.activeFiledIndex],
        id: this.programVoteList[this.activeFiledIndex].vote_id,
      });
    }
    this.value[this.activeFiledIndex] = e.text;
    this.programVoteList[this.activeFiledIndex] = {
      vote_id: e.id,
      type: this.chooseProgramId,
    };
    // const newColumns = JSON.parse(JSON.stringify(this.programme));
    this.columns.map((item: any, index: any) => {
      this.programVoteList.map((chooseItem: any) => {
        if (item.id === chooseItem.vote_id) {
          this.columns.splice(index, 1);
        }
      });
    });
    this.showPicker = false;
  }
  onPersonalConfirm(e: any) {
    console.log(e);
    this.value[this.activeFiledIndex] = e.text;
    this.personalVoteList.push({ vote_id: e.id, pro_id: e.proid });
    this.showPicker = false;
  }
  choosePersonal(index: any, item: any) {
    this.activeFiledIndex = index;
    if (!item.enable) {
      this.showPicker = false;
      return;
    }
    this.showPicker = true;
    const newSonPersonal: any = [];
    item.per_list.map((item: any) => {
      newSonPersonal.push({ id: item.id, proid: item.proid, text: item.title });
    });
    this.columns = newSonPersonal;
  }
}
